import { 
    BUHTABLE_RECORDS_GET_PENDING,
    BUHTABLE_RECORDS_GET_REJECTED,
    BUHTABLE_RECORDS_GET_FULFILLED,

    BUHTABLE_RECORD_CREATE_REJECTED,
    BUHTABLE_RECORD_CREATE_FULFILLED,

    BUHTABLE_RECORD_VALUES_SET,

    BUHTABLE_RECORD_UPDATE_PENDING,
    BUHTABLE_RECORD_UPDATE_REJECTED,
    BUHTABLE_RECORD_UPDATE_FULFILLED,

    BUHTABLE_RESET
    
} from '../_actions/buhtable';
import _ from 'lodash';

const initialState = {
    error: null,
    errorStatus: null,
    loading: false,
    source: [],
    summary: []
};

const buhtable = (state = initialState, action) => {
    switch(action.type) {
        case BUHTABLE_RECORDS_GET_PENDING: {
            return Object.assign({}, state, {
                error: null,
                errorStatus: null,
                loading: true,
                source: []
            });
        }

        case BUHTABLE_RECORDS_GET_REJECTED: {
            let error = action.error;
            if(_.hasIn(error, 'response.data.error')) {
                error = error.response.data.error
            };            
            return Object.assign({}, state, {
                error: error,
              //  errorStatus: status,
                source: []
            });            
        }

        case BUHTABLE_RECORDS_GET_FULFILLED: {
            return Object.assign({}, state, {
                error: null,
                errorStatus: null,
                loading: false,
                source: action.payload[0],
                summary: action.payload[1]
            });
        }

        case BUHTABLE_RECORD_CREATE_REJECTED: {
            let error = action.error.message;
            if(_.hasIn(error, 'response.data.error')) {
                error = JSON.parse(error.response.data.error).message
            };            
            return Object.assign({}, state, {
                error: error,
            });            
        }        

        case BUHTABLE_RECORD_CREATE_FULFILLED: {
            return Object.assign({}, state, {
                error: null,
                source: state.source.concat(action.payload)
            })
        }

        case BUHTABLE_RECORD_VALUES_SET: {
            return Object.assign({}, state, {
                error: null,
                errorStatus: null,
                source: _.map(state.source, record => {
                    return record.id === action.record.id
                        ? action.record
                        : record
                })
            })
        }

        case BUHTABLE_RECORD_UPDATE_PENDING: {
            return Object.assign({}, state, {
                error: null,
                //loading: true,
                //source: []
            });
        }
        
        case BUHTABLE_RECORD_UPDATE_REJECTED: {
            let error = action.error.message;
            if(_.hasIn(error, 'response.data.error')) {
                error = JSON.parse(error.response.data.error).message
            };            
            return Object.assign({}, state, {
                error: error,
                //source: []
            });            
        }

        case BUHTABLE_RECORD_UPDATE_FULFILLED: {
            const { source } = state;
            const { data } = action.payload;
            return Object.assign({}, state, {
                error: null,
                //errorStatus: null,
                //loading: false,
                source: _.map(source, record => {
                    return record.id === action.payload[0] && action.payload[0].id
                        ? action.payload[0]
                        : record
                }),
                summary: action.payload[1]
            });
        }
        
        case BUHTABLE_RESET: {
            return initialState
        }
        default: {
            return state
        }
    }
};

export default buhtable;


// WEBPACK FOOTER //
// ./src/_reducers/buhtable.js